module.exports = __webpack_public_path__ + "static/media/shuffle.02b9993d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/cards/shuffle.svg
// module id = 124
// module chunks = 0